module.exports = __webpack_public_path__ + "Groups0003-4bd6ec51fb4fdffd08fd65376acb46b4.png";